import {extendTheme} from '@chakra-ui/theme-utils'

import TextareaTheme from 'airship/design-system/theme/components/textarea'

import {accordionTheme} from './components/Accordion'
import badgeTheme from './components/Badge'
import buttonTheme from './components/Button'
import CalendarTheme from './components/Calendar'
import checkboxTheme from './components/Checkbox'
import formLabelTheme from './components/FormLabel'
import headingTheme from './components/Heading'
import inputTheme from './components/Input'
import linkTheme from './components/Link'
import modalTheme from './components/Modal'
import numberInputTheme from './components/NumberInput'
import OptionTheme from './components/Option'
import radioTheme from './components/Radio'
import SectionTheme from './components/Section'
import selectTheme from './components/Select'
import sliderTheme from './components/Slider'
import StatusBadgeTheme from './components/StatusBadge'
import SwitchTheme from './components/Switch'
import tagTheme from './components/Tag'
import textTheme from './components/Text'
import tooltipTheme from './components/Tooltip'
import breakpoints from './foundations/breakpoints'
import colors from './foundations/colors'
import opacities from './foundations/opacity'
import shadows from './foundations/shadow'
import sizes from './foundations/sizes'
import space from './foundations/space'
import typography from './foundations/typography'

const theme = extendTheme({
  space,
  fontSizes: typography.fontSizes,
  colors,
  fonts: typography.fonts,
  fontWeights: typography.fontWeights,
  lineHeights: typography.lineHeights,
  letterSpacing: sizes,
  breakpoints,
  opacities,
  shadows,

  components: {
    Accordion: accordionTheme,
    Badge: badgeTheme,
    Button: buttonTheme,
    Calendar: CalendarTheme,
    Checkbox: checkboxTheme,
    FormLabel: formLabelTheme,
    Heading: headingTheme,
    Input: inputTheme,
    Link: linkTheme,
    Modal: modalTheme,
    NumberInput: numberInputTheme,
    Option: OptionTheme,
    Radio: radioTheme,
    Section: SectionTheme,
    Select: selectTheme,
    Slider: sliderTheme,
    StatusBadge: StatusBadgeTheme,
    Switch: SwitchTheme,
    Tag: tagTheme,
    Text: textTheme,
    Textarea: TextareaTheme,
    Tooltip: tooltipTheme,
  },
  styles: {
    global: {
      body: {
        fontFamily: null,
        lineHeight: null,
        bg: '',
      },
    },
  },
})

export default theme
